// src/SkipMissedModal.jsx
// Created: September 24, 2025
// Simple modal for selecting between Skip and Missed status

import React from 'react';
import './SkipMissedModal.css';

const SkipMissedModal = ({ 
  isOpen, 
  onClose, 
  onSelectStatus, 
  medicationName 
}) => {
  if (!isOpen) return null;

  const handleSkip = () => {
    onSelectStatus('skipped');
    onClose();
  };

  const handleMissed = () => {
    onSelectStatus('missed');
    onClose();
  };

  const handleBackdropClick = (e) => {
    // Close if clicking outside the modal content
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content">
        <div className="modal-medication-name">
          {medicationName}
        </div>
        
        <div className="modal-buttons-row">
          <button 
            className="modal-button-simple skip" 
            onClick={handleSkip}
          >
             Skip &gt;
          </button>
          
          <button 
            className="modal-button-simple missed" 
            onClick={handleMissed}
          >
            Missed
          </button>
        </div>
      </div>
    </div>
  );
};

export default SkipMissedModal;